import request from '@utils/request';
import url from '@utils/url';

const { HOST } = url;

export async function auth() {
    const url = `${HOST}/cps-gateway/api/v1/admin/me
    `;
    return request({ method: 'get', url: url });
}

export async function getCaptcha() {
    const url = `${HOST}/cps-gateway/api/v1/admin/captcha`;

    return request({ method: 'get', url: url });
}

export async function getSMSCode(data) {
    const url = `${HOST}/cps-gateway/api/v1/admin/sms/send`;

    return request({ method: 'post', url: url }, data);
}

export async function submit(data) {
    const url = `${HOST}/cps-gateway/api/v1/admin/login`;

    return request({ method: 'post', url: url }, data);
}

export async function logout() {
    const url = `${HOST}/cps-gateway/api/v1/admin/logout`;

    return request({ method: 'get', url: url });
}

